import i18n from "../../../../constants/i18n";
import { CSR_MY_CSR_MISTAKES_HEADERS } from "../../../../constants/table-custom-headers/CSR";
import getMyCSRMistakesStore from "../../../../stores/csr-store/csr-mistakes";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";

const MyCSRMistakesTable = withLiteObserverAndTheme(() => {
  const auditedEvents = getMyCSRMistakesStore().myMistakesOrdered.get();

  return (
    <Et3Table
      columns={CSR_MY_CSR_MISTAKES_HEADERS}
      rows={auditedEvents}
      title={i18n.get("EVENTS_COUNT")}
      shouldBeFlagged={false}
      titleKey={"EVENTS_COUNT"}
    />
  );
});

export default MyCSRMistakesTable;
